// <head> metadata for AgenticAiBuilderEarlyAccessPage (https://www.dbos.dev/agentic-ai-builder-early-access).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Build Durable AI Agents with Open Source DBOS',
    },
    {
      name: 'description',
      content:
        'DBOS is a great platform for executing durable AI automation workflows. Sign up here to learn more and try it for free.',
    },
    {
      property: 'og:title',
      content: 'Build Durable AI Agents with Open Source DBOS',
    },
    {
      property: 'og:description',
      content:
        'DBOS is a great platform for executing durable AI automation workflows. Sign up here to learn more and try it for free.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/6777ff5094ea07ccff1fce0a_DBOS-Agentic-AI-Platform.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Build Durable AI Agents with Open Source DBOS',
    },
    {
      name: 'twitter:description',
      content:
        'DBOS is a great platform for executing durable AI automation workflows. Sign up here to learn more and try it for free.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/6777ff5094ea07ccff1fce0a_DBOS-Agentic-AI-Platform.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/agentic-ai-builder-early-access',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
